
import {
  IonPage,
  IonContent,
  IonHeader,
  IonButtons,
  IonBackButton,
  IonTitle,
  IonItem,
  IonLabel,
  IonInput,
  IonRow,
  IonCol,
  IonButton,
  toastController
} from '@ionic/vue'
import {RouterLink, useRouter} from "vue-router";
import firebase from "firebase";
import {useI18n} from "vue-i18n";

import {defineComponent,ref,Ref} from "vue";
import HomeButton from "@/components/HomeButton.vue";


export default defineComponent({
  components: {
    HomeButton,
    IonPage, IonContent, IonHeader, IonButtons, IonBackButton,IonTitle, IonItem, IonLabel, IonInput, IonRow, IonCol, IonButton, RouterLink},
  name: "Login",
  data() {
    return {

    };
  },
  methods: {

    async submit() {
      const email = this.email;
      const password = this.password;
      console.log(email,password);
      if (!email || !password) {
        this.error = "Email and Password Required";
        return;
      }
      await firebase.auth().setPersistence(firebase.auth.Auth.Persistence.SESSION)
      const result = await firebase
          .auth()
          .signInWithEmailAndPassword(email.trim(), password)
          .then((data) => {
            console.log("loggedin", data)
            // data.user
            // .updateProfile({
            //   displayName: form.name
            // })
            // .then(() => {
            //   console.log("registered");
            // });
            // console.log("registered");
            this.router.push({name:"Timeline"});
            return {data:data,error:null};
          })
          .catch((err) => {
            console.log("login failed", err);
            return {data:null,error:err}
          });
      console.log
      console.log(result);

      if(result.error) (await toastController.create({message:result.error.message, color:"danger", position:"top",duration:2000})).present();

    }
  },
  setup() {

    const router = useRouter()
    const i18n = useI18n()
    const data = {
      email: "",
      password: "",
      error: ""
    }

    return {
      router,
      i18n,

      ...data,
    }
  }
})
